import { DashboardShell } from "@/components/dashboard-shell"
import { InsightsFilterBar } from "@/components/analytics/insights-filter-bar"
import { InsightsProvider } from "@/components/analytics/insights-provider"
import { CampaignsBody } from "@/components/campaigns/lens-partner"
import { createFileRoute } from "@tanstack/react-router"
import { RouteLoading, CampaignsLoadingSkeleton } from "@/components/route-loading"
import { InsightsError } from "@/components/analytics/insights-error"

export const Route = createFileRoute("/campaigns")({
  component: CampaignsPage,
  head: () => ({ meta: [{ title: "Campaigns" }] }),
  pendingComponent: CampaignsPending,
  errorComponent: ({ reset }) => <InsightsError page="Campaigns" retry={reset} />,
})

// PRIORITY LENS 1 — partner / referral attribution (PRD §6, v9 §11.4).
// Attribution only: HQ carries partner / campaign / referred-by for credit and
// tracks no affiliate money (v9 §0.3). Nothing on this page is paid media —
// Veez has never bought an ad; business arrives through partners, referrals,
// Maps scrapes and walking into shops.
//
// Built from the same summary-kit widgets as /analytics: headline tiles, the
// funnel and source mix, ranked partner / referrer / campaign cards, and one
// folded table with every number.

function CampaignsPage() {
  return (
    <DashboardShell>
      <InsightsProvider initialFilters={{ period: "90d" }}>
        <div className="flex flex-col gap-4">
          <InsightsFilterBar page="campaigns" initialPeriod="90d" title="Referrals & attribution" />
          <CampaignsBody />
        </div>
      </InsightsProvider>
    </DashboardShell>
  )
}

// Shown while this route's chunk (and the ReUI components in it)
// downloads. Was src/app/campaigns/loading.tsx.
function CampaignsPending() {
  return (
    <RouteLoading>
      <CampaignsLoadingSkeleton />
    </RouteLoading>
  )
}
